//import AllExercises from '../utente/AllExercises'
import React, { useState, useRef }  from 'react';

import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';
import { alpha, useTheme } from '@mui/material/styles';
import {ImageBackdrop, ImageSrc} from '../imageButton';

import AddPopUp from '../popUps/AddPopUp'
import PopUp from '../popUps/PopUp'
import VerExPopUp from '../popUps/VerExPopUp'
import EditExerc from '../popUps/EditExerc'
import DeleteExerc from '../popUps/DeleteExerc'
import ChangeOrderExs from '../popUps/ChangeOrderExs'
import AddExsToSession from '../popUps/AddExsToSession'

import EditSessao from '../popUps/EditSessao'

import './Carrousel.css';
import '../popUps/styles.css';

//import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
//import EmojiPeopleIcon from '@mui/icons-material/EmojiPeople';
import RepeatIcon from '@mui/icons-material/Repeat';
//import RestartAltIcon from '@mui/icons-material/RestartAlt';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TimerIcon from '@mui/icons-material/Timer';

import {
    Grid,
    Card, 
    Stack,
    IconButton,
    CardContent,
    Box,
    Divider,
    Chip,
    Typography,
    Button,
    Container,
    Tooltip
} from '@mui/material';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

import ArrowCircleRightSharpIcon from '@mui/icons-material/ArrowCircleRightSharp';
import ArrowCircleLeftSharpIcon from '@mui/icons-material/ArrowCircleLeftSharp';
import ChangeCircleIcon from '@mui/icons-material/ChangeCircle';

import dadosSessoes from '../utente/DadosSessoes'

import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { makeStyles, withStyles } from "@mui/styles";


const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: "#fff",//theme.palette.background.paper,
    }
  }));
  
export default function GerirPlanos() {
    const theme = useTheme();
    const carousel = useRef(null);
    
    const MuiListItem = withStyles({
        root: {
          "&$selected": {
            backgroundColor: alpha(theme.palette.primary.main, 0.4),
            color: theme.palette.text.secondary,
            borderRadius: '60px 120px 120px 60px',
          },
          "&$selected:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.35),
            color: "primary.main",
            borderRadius: '60px 120px 120px 60px',
          },
          "&:hover": {
            backgroundColor: alpha(theme.palette.primary.main, 0.08),
            color: "primary.main",
            borderRadius: '60px 120px 120px 60px',
          },
          color: theme.palette.text.secondary,
        },
        selected: {},

      })(ListItem);
    

    const classes = useStyles();

    const [selectedIndex, setSelectedIndex] = React.useState(0);
    
    const [addPopUp, setAddPopUp] = useState(false);
    const [deletePopUp, setDeletePopUp] = useState(false);
    const [editPopUp, setEditPopUp] = useState(false);

    const [editExPopUp, setEditExPopUp] = useState(false);
    const [deleteExPopUp, setDeleteExPopUp] = useState(false);
    const [ordemExPopUp, setOrdemExPopUp] = useState(false);
    const [addExPopUp, setAddExPopUp] = useState(false);

    const [verEx, setVerEx] = useState(false);

    const [itemVisible,setItemVisible] = useState(null);
    const [editVisible,setEditVisible] = useState(null);
    const [deleteVisible,setDeleteVisible] = useState(null);

    const handleLeftClick = (e) =>{
        e.preventDefault();
        carousel.current.scrollLeft -= carousel.current.offsetWidth;
    }

    const handleRightClick = (e) =>{
        e.preventDefault();
        carousel.current.scrollLeft += carousel.current.offsetWidth;
    }
    
    function showContent(index){
        setVerEx(true);
        setItemVisible(itemVisible => itemVisible === index ? index : index);
    }

    function editContent(index){
        setEditExPopUp(true);
        setEditVisible(editVisible => editVisible === index ? index : index);
    }

    function deleteEx(index){
        setDeleteExPopUp(true);
        setDeleteVisible(deleteVisible => deleteVisible === index ? index : index);
    }

    const [sessao, setSessao] = useState(dadosSessoes[0]); 
   
    function handleClick(event, index, itemSessao){
        setSessao(
            itemSessao
        );
        setSelectedIndex(index);
    };

    /*
    useEffect(() => {
        fetch("http://localhost:3000/static/sessoes.json")
            .then(res => res.json())
            .then(
                (data) => {
                    setIsLoaded(true);
                    setdadosSessoes(data);
                })
            .catch((error) => {
                setIsLoaded(true);
                setError(error);
            });
    },[addExPopUp, editExPopUp, addPopUp, editPopUp, deletePopUp, deleteExPopUp, ordemExPopUp]);
    */

    /*
    if (error) {
        return <Typography>Error: {error.message}</Typography>;
    } else if (!isLoaded) {
        return <Box sx={{ display: 'flex', marginTop:30 }}
                    alignItems="center"
                    justifyContent="center">
                    <CircularProgress/>
                </Box>
    } else {
        */
        
        return(
        <Card>
            <CardContent >
                <Grid container spacing={2}>
                    <Grid item xs={12} md={3} lg={3} >
                        <Typography sx={{margin: 1}} variant="h4">
                        Planos de Sessão
                        </Typography>

                        <List className={classes.root} component="nav">
                            {dadosSessoes.map((itemSessao, index) => {
                                return (   
                                    // menu - escolher sessao
                                    <MuiListItem 
                                        button key={index}
                                        selected={selectedIndex === index}
                                        onClick={(event) => handleClick(event, index, itemSessao)}
                                        sx={{
                                            color: 'text.primary',
                                            fontWeight: 'fontWeightMedium',
                                        }}
                                        >
                                        <ListItemText primary ={itemSessao.title} />
                                    </MuiListItem>
                                );
                            })}
                        </List>

                        <Tooltip title="Criar Novo Plano de Sessão">
                            <Button fullWidth variant="contained" endIcon={<AddIcon fontSize="inherit" />} aria-label="add" size="medium" onClick = {() => setAddPopUp(true)}>
                                Criar
                            </Button>
                        </Tooltip>

                    </Grid>
                   
                   {/* Ecrã da sessão selecionada */}
                    <Grid item xs={12} md={9} lg={9}>
                        <Stack direction = "row" alignItems="center"  spacing={1} margin={1}>
                            <Typography variant="h5">
                                {sessao.title}
                            </Typography>
                            <Box paddingLeft={1}>

                                <Tooltip title="Editar Sessão">
                                    <Button variant="outlined" endIcon={<EditIcon fontSize="inherit" />} aria-label="add" size="medium" onClick = {() => setEditPopUp(true)}>
                                        Editar
                                    </Button>
                                </Tooltip>

                                <EditSessao trigger={editPopUp} sessao={sessao} setTrigger={setEditPopUp}/>

                                
                                <Tooltip title="Apagar Sessão">
                                    <Button variant="outlined" endIcon={<DeleteIcon fontSize="inherit" />} aria-label="add" size="medium" onClick = {() => setDeletePopUp(true)}>
                                        Apagar
                                    </Button>
                                </Tooltip>
                                
                                <PopUp trigger={deletePopUp} setTrigger={setDeletePopUp}>
                                    <Typography align="center" variant="h5">Deseja apagar a Sessão "{sessao.title}"?</Typography>
                                    <Box textAlign='center' margin={2}>
                                        <Button variant='contained' color='error' size="medium">Apagar</Button>
                                        <Button variant='contained' color='inherit' sx={{marginLeft:3,  align:"center"}}  onClick={() => setDeletePopUp(false)}>Cancelar</Button>
                                    </Box>
                                </PopUp>
                            </Box>
                        </Stack>

                        <Divider margin={2} spacing={1}/>
                        <Box margin={1.0}>
                            <Typography variant="h6">Descrição</Typography>
                            <Typography variant="body2">{sessao.text}</Typography>
                            
                            <Box paddingTop={1}>
                                <Stack direction = "row" alignItems="center"> 
                                {/* adicionar mais espaço, para os exercícios irem para baixo */}
                                    <Typography variant="h6">Exercícios</Typography>
                                    <Box paddingLeft={1}>
                                        <Tooltip title="Adicionar Exercícios à Sessão">
                                            <Button variant="outlined" endIcon={<AddIcon fontSize="inherit" />} aria-label="add" size="small" onClick = {() => setAddExPopUp(true)}>
                                                Adicionar
                                            </Button>
                                        </Tooltip>

                                        {/* popup adicionar exercicios à sessao... */}
                                        <AddExsToSession trigger={addExPopUp} sessao={sessao} setTrigger={setAddExPopUp}/>

                                        {/* Trocar ordem dos exercicios */} 
                                        <Tooltip title="Reoordenar Exercícios da Sessão">
                                            <Button variant="outlined" endIcon={<ChangeCircleIcon fontSize="inherit" />} aria-label="add" size="small" onClick={() => setOrdemExPopUp(true)}>
                                                Reoordenar
                                            </Button>
                                        </Tooltip>
                                        <ChangeOrderExs trigger={ordemExPopUp} sessao={sessao} setTrigger={setOrdemExPopUp}/>

                                    </Box>
                                </Stack>
                            </Box>

                            <Container className="container">
                                <Stack direction="row">
                                    <IconButton size="large" color='primary' className="buttons"  onClick={handleLeftClick}>
                                        <ArrowCircleLeftSharpIcon fontSize="inherit" />
                                    </IconButton>
                               
                                <Box className="carousel" ref={carousel}>
                                    {sessao.exercises?.map((item, index) => {
                                        return(
                                            <Card className="item" key={index}>
                                                <Box sx={{ 
                                                        alignItems:'center',
                                                        display:'flex',
                                                        position: 'relative',
                                                        height: 200
                                                        }}>
                                                    <ImageSrc style={{ backgroundImage: `url(${item.url})` }} />
                                                    <ImageBackdrop className="MuiImageBackdrop-root" /> 
                                                    <Stack sx={{
                                                                alignItems:'center', 
                                                                margin: 1,
                                                                padding: 0,
                                                                borderRadius: 0,
                                                                position: 'absolute',
                                                                left: 0,
                                                                right: 0,
                                                                top: 0,
                                                                bottom: 0,
                                                                display: 'flex',//block
                                                                textAlign: 'center',
                                                                justifyContent: 'center',
                                                                color: theme.palette.common.white,
                                                            }}>
                                                        <Typography component="span" variant="h5">{item.name}</Typography>
                                                        {item.category.map((item) => {
                                                            return (
                                                                <Typography component="span" key={item} variant="body2">{item}</Typography> 
                                                            );
                                                        })}                                                          
                                                    </Stack>
                                                </Box>
                                                <Divider margin={2} spacing={2}/>

                                                <Grid container>
                                                    <Box sx={{ paddingLeft: 2,paddingTop:0.5, paddingRight:2, paddingBottom:0.5,
                                                        display:'flex',alignItems: 'center', textAlign: 'center',flexWrap: 'wrap' }}>
                                                    
                                                        <Grid item xs={2} md={2} lg={2}>
                                                            <RepeatIcon  />
                                                        </Grid>

                                                        <Grid item xs={10} md={10} lg={10}>
                                                            <Typography component="span" style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="subtitle2">
                                                                {item.reps} Repetições 
                                                            </Typography>

                                                            <Typography component="span" style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="subtitle2">
                                                                {item.series} Séries
                                                            </Typography>
                                                        </Grid>


                                                        <Grid item xs={2} md={2} lg={2}>
                                                            <AccessTimeIcon />
                                                        </Grid>

                                                        <Grid item xs={10} md={10} lg={10}>
                                                            <Typography component="span" style ={{paddingLeft: 10, paddingTop: 7,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="subtitle2">
                                                                    Descanso Após
                                                            </Typography>

                                                            <Typography component="span" style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="body2">
                                                                    Série: {item.descansoAposSerie} seg
                                                            </Typography>

                                                            <Typography component="span" style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="body2">
                                                                Exercício: {item.descansoAposExercicio} seg
                                                            </Typography>
                                                        </Grid>

                                                        
                                                        <Grid item xs={2} md={2} lg={2}>
                                                            <TimerIcon/>
                                                        </Grid>

                                                        <Grid item xs={10} md={10} lg={10}>
                                                            <Typography style ={{paddingLeft: 10, paddingTop: 7,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="subtitle2">
                                                                    Tempo
                                                            </Typography>

                                                            <Typography style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="body2">
                                                                    Limite: {item.tempoLimite} seg
                                                            </Typography>

                                                            <Typography style ={{paddingLeft: 10,
                                                                    display: 'flex', 
                                                                    alignItems: 'center', justifyContent: 'spaceBetween',
                                                                    flexWrap: 'wrap'  }}
                                                                    variant="body2">
                                                                Permanência: {item.tempoManutencao} seg
                                                            </Typography>
                                                        </Grid>
                                                    </Box>
                                                </Grid>
                                                
                                                <Divider margin={2} spacing={2} />
                                                
                                                <Stack direction="row"
                                                    alignItems="center"
                                                    justifyContent="space-between"
                                                    sx={{ px: 1, py: 0.5}}>
                                                
                                                <Button color='primary' endIcon={<FitnessCenterIcon/>} 
                                                    variant="contained" size="small" onClick ={() => showContent(index)}
                                                    >Instruções 
                                                </Button>
                                                {itemVisible === index && <VerExPopUp trigger={verEx} content={item} setTrigger={setVerEx}/> }
                                                
                                                <Box>
                                                    <Tooltip color='primary' title="Editar">
                                                        <IconButton onClick ={() => editContent(index)}>
                                                            <EditIcon/>
                                                        </IconButton>
                                                    </Tooltip>
                                                    {editVisible === index && <EditExerc trigger={editExPopUp} content={item} setTrigger={setEditExPopUp}/> }
                                                    
                                                    <Tooltip color='primary' title="Apagar">
                                                        <IconButton onClick ={() => deleteEx(index)}>
                                                            <DeleteIcon />
                                                        </IconButton>
                                                    </Tooltip>
                                                    {deleteVisible === index && <DeleteExerc trigger={deleteExPopUp} content={item} setTrigger={setDeleteExPopUp}/> }
                                                </Box>
                                            </Stack>
                                        </Card>
                                        );
                                    })}
                                </Box>
                                
                                <IconButton  size="large" className="buttons" color='primary' onClick={handleRightClick}>
                                    <ArrowCircleRightSharpIcon fontSize="inherit" />
                                </IconButton>
                                </Stack>
                            </Container>
                        </Box>     
                    </Grid>
                </Grid>                
                <AddPopUp trigger={addPopUp} setTrigger={setAddPopUp}/>
            </CardContent>
        </Card>
    );
}

export { default as GerirPlanos } from './GerirPlanos';
